import { useCallback, useState } from 'react'

// TODO Finish this https://setplexapps.atlassian.net/browse/FP-3098
export const ProgramView = ({ onCloseClick }) => {
  // onClick outside -> onCloseClick()

  const handleCloseClick = (event) => {
    event.stopPropagation()
    event.preventDefault()
    onCloseClick()
  }

  return (
    <div
      style={{ minWidth: '400px', minHeight: '600px', backgroundColor: 'grey' }}
    >
      <h1>Program View</h1>
      <h1>
        <button onClick={handleCloseClick}>close</button>
      </h1>
    </div>
  )
}

export const useProgramViewState = ({ safeToShow }) => {
  const [isProgramOpened, setIsProgramOpened] = useState(false)

  const onProgramClick = useCallback(() => {
    if (safeToShow) {
      setIsProgramOpened((opened) => {
        if (opened) {
          return false
        } else {
          return safeToShow
        }
      })
    }
  }, [safeToShow])

  const onCloseProgram = useCallback(() => setIsProgramOpened(false), [])

  return { isProgramOpened, onProgramClick, onCloseProgram }
}
